
<div class="cp-no-chance">
  <div class="button" @click="handleAddress"></div>
  <Close is-mobile @close="handleClose" class="close"></Close>
</div>
